import { Textarea } from '@/components/ui/textarea';
import type { ArrayFormControlProps } from '@/pages/WorkflowsCatalog/components/run/controls/types';
import type { FieldValues } from 'react-hook-form';

const ArrayFormControl = <T extends FieldValues>({ field, itemType }: ArrayFormControlProps<T>) => {
  const value = Array.isArray(field.value) ? field.value.join(', ') : '';
  return (
    <Textarea
      value={value}
      onChange={(e) => {
        const rawValue = e.target.value;
        let values: unknown[] = rawValue
          .split(',')
          .map((v) => v.trim())
          .filter(Boolean);
        if (itemType === 'number') {
          values = (values as string[]).map((v) => (v === '' ? '' : Number(v)));
        } else if (itemType === 'boolean') {
          values = (values as string[]).map((v) => v === 'true');
        }
        field.onChange(values);
      }}
      placeholder="Enter values separated by commas (e.g., stripe.com, webflow.com)"
    />
  );
};

export default ArrayFormControl;
